import { useStorage } from "app/custom-hooks/storage/useStorage";

import { industryStorage } from "../services/storage";

import { useIsIndustryTaxonomyOptedIn } from "./useIsIndustryTaxonomyOptedIn";
import { useShowsIndustryTaxonomyAdminOffer } from "./useShowsIndustryTaxonomyAdminOffer";

/**
 * Whether the SI homepage industry-taxonomy banner would render (launch banner for opted-in accounts,
 * demo banner for legacy admins). Lower-priority homepage banners must stay hidden while this is true.
 */
export const useShowsIndustryTaxonomyHomeBanner = (): boolean => {
    const isIndustryTaxonomyOptedIn = useIsIndustryTaxonomyOptedIn();
    const showsAdminOffer = useShowsIndustryTaxonomyAdminOffer();
    const [isLaunchBannerDismissed] = useStorage<boolean>(industryStorage.launchBannerDismissed);

    return isIndustryTaxonomyOptedIn ? !isLaunchBannerDismissed : showsAdminOffer;
};
